import { Fragment } from 'react'

import { EMPTY_LIST } from '../../../../constants/common'
import { ChatroomSystemMessageUserLink } from '../ChatroomSystemMessageUserLink'

function ChatroomSystemMessageUserListLinks({ linkClassName, users }) {
  return (users || EMPTY_LIST).map((user, index) => (
    <Fragment key={user?.id ?? index}>
      {index > 0 ? ', ' : null}
      <ChatroomSystemMessageUserLink className={linkClassName} user={user} />
    </Fragment>
  ))
}

export default ChatroomSystemMessageUserListLinks
